import { z } from 'zod';
import { ADJUST_FIELDS } from './adjust-fields.js';
export const moveInventoryInputSchema = z.object({
    requestId: ADJUST_FIELDS.requestId(),
    tagId: ADJUST_FIELDS.id('Stock'),
    destinationLocationId: ADJUST_FIELDS.id('Destination bin'),
    quantity: ADJUST_FIELDS.quantity(),
    note: ADJUST_FIELDS.note(),
});
//# sourceMappingURL=move-input.js.map